import React from "react";
import { Tabs } from "antd";
import History from "./History";
import QuestionsList from "./QuestionsList";

const List = () => {
  const tabItems = [
    {
      key: "1",
      label: "Historial Formularios Pre Operacional",
      children: <History />,
    },
    {
      key: "2",
      label: "Formulacion Preguntas Pre Operacional",
      children: <QuestionsList />,
    },
  ];

  return <Tabs defaultActiveKey="1" centered items={tabItems} />;
};

export default List;
